import React from 'react';
import { XCircleIcon } from 'lucide-react';
interface FilterProps {
  filters: {
    countries: string[];
    sectors: string[];
    budgetMin: string;
    budgetMax: string;
    dateRange: any;
  };
  onFilterChange: (filters: any) => void;
}
export function SearchFilters({
  filters,
  onFilterChange
}: FilterProps) {
  const removeCountry = (country: string) => {
    onFilterChange({
      countries: filters.countries.filter(c => c !== country)
    });
  };
  const removeSector = (sector: string) => {
    onFilterChange({
      sectors: filters.sectors.filter(s => s !== sector)
    });
  };
  const clearBudget = () => {
    onFilterChange({
      budgetMin: '',
      budgetMax: ''
    });
  };
  const clearDateRange = () => {
    onFilterChange({
      dateRange: null
    });
  };
  const clearAllFilters = () => {
    onFilterChange({
      countries: [],
      sectors: [],
      budgetMin: '',
      budgetMax: '',
      dateRange: null
    });
  };
  // Count active filters
  const activeFilterCount = filters.countries.length + filters.sectors.length + (filters.budgetMin || filters.budgetMax ? 1 : 0) + (filters.dateRange ? 1 : 0);
  if (activeFilterCount === 0) return null;
  return <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-725">
      <div className="flex items-center justify-between mb-3" data-id="element-726">
        <h3 className="text-sm font-medium text-gray-700" data-id="element-727">
          Filtres appliqués ({activeFilterCount})
        </h3>
        <button onClick={clearAllFilters} className="text-sm text-blue-600 hover:text-blue-800" data-id="element-728">
          Effacer tous les filtres
        </button>
      </div>
      <div className="flex flex-wrap gap-2" data-id="element-729">
        {filters.countries.map(country => <div key={country} className="inline-flex items-center px-2.5 py-1.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-730">
            Pays: {country}
            <button onClick={() => removeCountry(country)} className="ml-1.5 text-blue-600 hover:text-blue-800" data-id="element-731">
              <XCircleIcon size={14} data-id="element-732" />
            </button>
          </div>)}
        {filters.sectors.map(sector => <div key={sector} className="inline-flex items-center px-2.5 py-1.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-733">
            Secteur: {sector}
            <button onClick={() => removeSector(sector)} className="ml-1.5 text-green-600 hover:text-green-800" data-id="element-734">
              <XCircleIcon size={14} data-id="element-735" />
            </button>
          </div>)}
        {(filters.budgetMin || filters.budgetMax) && <div className="inline-flex items-center px-2.5 py-1.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-736">
            Budget: {filters.budgetMin ? `Min ${filters.budgetMin}€` : ''}{' '}
            {filters.budgetMin && filters.budgetMax ? ' - ' : ''}{' '}
            {filters.budgetMax ? `Max ${filters.budgetMax}€` : ''}
            <button onClick={clearBudget} className="ml-1.5 text-yellow-600 hover:text-yellow-800" data-id="element-737">
              <XCircleIcon size={14} data-id="element-738" />
            </button>
          </div>}
        {filters.dateRange && <div className="inline-flex items-center px-2.5 py-1.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800" data-id="element-739">
            Date: {filters.dateRange.start} - {filters.dateRange.end}
            <button onClick={clearDateRange} className="ml-1.5 text-purple-600 hover:text-purple-800" data-id="element-740">
              <XCircleIcon size={14} data-id="element-741" />
            </button>
          </div>}
      </div>
    </div>;
}